import _ from 'lodash'
import API from '../utilities/API'

const activeCodes = {
  1: 'Active',
  2: 'Created',
  3: 'Inactive',
  4: 'Rejected',
  5: 'Unknown',
  6: 'Deleted'
}

class PaymentOptions {
  static activeStatus (code) {
    return activeCodes[code]
  }

  static all () {
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({url: 'fetchAllPaymentOptions'})
        .then(response => {
          if (response.SUCCESS) {
            let result = []
            _.forIn(response.DATA.countries, (value, key) => {
              let payerClients = []

              _.forIn(response.DATA.payerClients[key], (value, key) => {
                payerClients = _.union(payerClients, value)
              })

              result.push({
                title: value.countryName,
                options: payerClients
              })
            })

            resolve(result)
          } else {
            reject(response)
          }
        })
        .catch(response => {
          reject(response)
        })
    })
  }

  static forService ({ serviceCode }) {
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({url: 'fetchServicePaymentOptions', data: { serviceCode }})
        .then(response => {
          if (response.SUCCESS) {
            let result = []
            _.forIn(response.DATA.countries, (value, key) => {
              let payerClients = []

              _.forIn(response.DATA.payerClients[key], (payerClientsObj, key) => {
                _.forIn(payerClientsObj, (value, key) => {
                  payerClients = _.union(payerClients, value)
                })
              })

              result.push({
                title: value.countryName,
                options: payerClients
              })
            })

            resolve(result)
          } else {
            reject(response)
          }
        })
        .catch(response => {
          reject(response)
        })
    })
  }

  static updatePaymentOption (payload, active) {
    console.log('UpdatePaymentOption() => payload passed: ', payload)
    // Check the active or inactive value
  }
}

export default PaymentOptions



// WEBPACK FOOTER //
// ./src/api/services/paymentOption.js